import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { currencyFormat, dateFormatterForUS, ratePercentageFormat } from '../../../utils/formatHelper';
import { DATE_TYPE_TOTAL } from './consts';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';
import { getTotalCancellationValue } from '../../pages/Analytics/utils';
import { roundDollarsFromCents } from '../../../utils/analytics';

export function SalesByChannelRow(props) {
  const { row } = props;
  const { currentCurrency } = useSelector((state) => state.analytics);
  const { dateType, visibleColumns } = useSelector((state) => state.analytics.reports.sales);

  const currentGmv = useMemo(() => row.gmv[currentCurrency], [row.gmv, currentCurrency]);
  const aov = row.unit_count.all_orders > 0 ? roundDollarsFromCents(currentGmv.all_orders / row.total_orders_count) : 0;
  const netSales = currentGmv.all_orders - getTotalCancellationValue(currentGmv) - currentGmv.returns;
  const returnedValue = currentGmv.returns ? currencyFormat(currentGmv.returns, currentCurrency) : 0;
  const returnRate =
    row.unit_count.all_orders > 0 && row.unit_count.returns > 0
      ? ratePercentageFormat(row.unit_count.returns / row.unit_count.all_orders)
      : NO_VALUE_PLACEHOLDER;

  const totalCancellationValue = getTotalCancellationValue(currentGmv);
  const totalCancellationUnitCount = getTotalCancellationValue(row.unit_count);
  const cancellationValue = totalCancellationValue ? currencyFormat(totalCancellationValue, currentCurrency) : 0;

  const cancellationRate =
    row.unit_count.all_orders > 0 && totalCancellationUnitCount > 0
      ? ratePercentageFormat(totalCancellationUnitCount / row.unit_count.all_orders)
      : NO_VALUE_PLACEHOLDER;

  return (
    <tr>
      {dateType !== DATE_TYPE_TOTAL && <td>{dateFormatterForUS(row.date)}</td>}
      {visibleColumns.includes('retailerId') && <td>{row.retailer_name}</td>}
      {visibleColumns.includes('country') && <td>{row.country_name}</td>}
      {visibleColumns.includes('ordersCount') && <td>{row.total_orders_count}</td>}
      {visibleColumns.includes('unitsCount') && <td>{row.unit_count.all_orders}</td>}
      {visibleColumns.includes('gmv') && <td>{currencyFormat(currentGmv.all_orders, currentCurrency)}</td>}
      {visibleColumns.includes('aov') && <td>{currencyFormat(aov, currentCurrency)}</td>}
      {visibleColumns.includes('returnedUnitsCount') && <td>{row.unit_count.returns}</td>}
      {visibleColumns.includes('returnedValue') && <td>{returnedValue}</td>}
      {visibleColumns.includes('returnRate') && <td>{returnRate}</td>}
      {visibleColumns.includes('cancelledUnitsCount') && <td>{getTotalCancellationValue(row.unit_count)}</td>}
      {visibleColumns.includes('cancellationsValue') && <td>{cancellationValue}</td>}
      {visibleColumns.includes('cancellationRate') && <td>{cancellationRate}</td>}
      {visibleColumns.includes('netSales') && <td>{currencyFormat(netSales, currentCurrency)}</td>}
      {visibleColumns.includes('orderType') && <td>{row.order_type ?? NO_VALUE_PLACEHOLDER}</td>}
    </tr>
  );
}

SalesByChannelRow.propTypes = {
  row: PropTypes.object.isRequired,
};
